var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { defaultActionsClasses } from "../../constants";
import { PopupMessageDefaultConfig } from "sb-resp-ui";
export var getPopupActionsConfig = function (configActions, context) {
    var actions = __assign({}, PopupMessageDefaultConfig.actions);
    Object.keys(configActions).forEach(function (key) {
        actions[key] = {};
        var defaultKey = defaultActionsClasses.hasOwnProperty(key) ? key : "default";
        actions[key].classes = typeof configActions[key].classes === "string" ? "" + configActions[key].classes : "" + defaultActionsClasses[defaultKey].classes;
        actions[key].text = configActions[key].text;
        actions[key].focus = configActions[key].focus || false;
        actions[key].onClick = configActions[key].callback || context.hide;
        actions[key].context = configActions[key].context || context;
    });
    return actions;
};
//# sourceMappingURL=getPopupActionsConfig.js.map